module.exports = __webpack_public_path__ + "./images/2b4a5061d2033a4613f097626ec295fb.webp";